<template>
  <div class="common-layout">
    <el-container>
      <el-header>
        <div style=" display: flex">
          <el-button type="primary" plain @click="refresh">刷新</el-button>
          <el-input v-model="inputOrderNo" style="width: 20%;position: relative;margin-left: 30px"
                    placeholder="输入工单号查询"
                    clearable></el-input>
          <!--          <el-button type="primary" @click="searchByOrderNo">查询</el-button>-->
          <el-input v-model="search" style="width: 30%;position: relative; margin-left: 30px" maxlength="50"
                    show-word-limit
                    placeholder="输入使用单位"
                    clearable>
          </el-input>
          <!--          <el-button type="primary" @click="qSearch">查询</el-button>-->
          <el-date-picker
              v-model="createDateSearch"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="width: 250px;left: auto; margin-left: 30px"
              clearable
          >
          </el-date-picker>
          <el-button type="primary" plain @click="searchByCreateDate">查询</el-button>
        </div>
      </el-header>
      <!--表格展示-->
      <el-main>
        <el-table
            :data="tableData"
            style="width: 100%;height: 50vh"
            border
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" min-width="30" max-width="60" />
          <el-table-column label="工单号" min-width="140" max-width="200" prop="orderNo"/>
          <el-table-column label="电梯号" min-width="60" max-width="120" prop="liftId"/>
          <!--          <el-table-column label="安装地址" prop="detailArea"/>-->
          <el-table-column label="产品编号" min-width="88" max-width="120"   prop="liftNum"/>
          <el-table-column label="使用单位" min-width="188" max-width="200" prop="unit"/>
          <!--          <el-table-column label="使用单位代码" prop="unitCode"/>-->
          <!--          <el-table-column label="单位内编码" prop="unitNum"/>-->
          <el-table-column label="设备品种" prop="liftType"/>
          <el-table-column label="创建时间" min-width="140" max-width="200" prop="createDate" sortable>
            <template v-slot="scope">
              <span>{{ this.formatDate(scope.row.createDate, "yyyy-MM-dd hh:mm:ss") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="检测员" prop="userAlias"/>
          <el-table-column label="操作" min-width="70" max-width="120" fixed="right">
            <template #default="scope">
              <el-button type="primary" plain size="small" style="margin-left: 0px;"
                         @click="getOrder(scope.row)">领取
              </el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-main>
      <el-button
          style="width: 96px ;height:24px;position: relative ;left: 90%;font-weight: bold"
          type="info" plain
          @click="allocationInBatch()"
      >批量领取工单
      </el-button>
      <!--        分页-->
      <el-footer>
        <div class="demonstration" style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[10, 20]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
        <!--                :disabled="disabled"-->
      </el-footer>
    </el-container>
    <!--    领取工单弹窗-->
    <el-dialog v-model="allocationDialog" title="领取工单" :lock-scroll="false"
               draggable :before-close="closeAllocation">
      <el-form :model="allocationForm" ref="form" status-icon label-width="160px">
        <el-select v-model="selectUserName" clearable multiple placeholder="请选择辅检人员" @click="userNameByLiftId()">
          <el-option
              v-for="(item,index ) in options"
              :key="item.userId"
              :label="item.userAlias"
              :value="index">
          </el-option>
        </el-select>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
                        <el-button @click="closeAllocation">关闭</el-button>
                        <el-button type="primary" @click="update()"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>

    <!--    批量领取工单弹窗-->
    <el-dialog v-model="allocationDialogInBatch" title="批量领取工单,选择辅检人员" :lock-scroll="false"
               draggable :before-close="closeBatch">
      <el-form :model="allocationInbatchForm" ref="form" status-icon label-width="160px">
        <el-container>
          <el-aside width="300px" style="margin-top: 20px">
            <el-text>
              请点击选择区域
            </el-text>

            <el-tree :data="treeData"
                     :props="defaulareaIdtProps"
                     node-key=""
                     ref="tree"
                     highlight-current
                     :default-expanded-keys="treeData"
                     :expand-on-click-node="false"
                     @node-click="handleNodeClickInbatch">
              <template #default="{ node }">
                        <span class="custom-tree-node">
                          <span>{{ node.data.areaName }}</span>
                          <span class="custom-tree-node-areaName">
                          </span></span></template>
            </el-tree>
          </el-aside>

          <el-main v-show="show2" style="height: 50%;margin-top: 40px">
            <el-table
                :data="tableDataAdd"
                style="width: 100%"
                border
                @selection-change="(data) => {
                  toggleRowArr = data
                }"
                :row-class-name="tableRowClassName1"
            >
              <el-table-column type="selection"/>
              <el-table-column label="检测员" prop="userAlias"/>
            </el-table>
            <!--        分页-->
            <el-footer>
              <div class="demonstration" style="margin: 10px 0">
                <el-pagination v-model:currentPage="currentPage1"
                               v-model:page-size="pageSize1"
                               :page-sizes="[10, 20]"
                               :small="small1"
                               :background="background1"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total1"
                               :prev="prev1"
                               :pager="pager1"
                               :next="next1"
                               :jumper="jumper1"
                               @size-change="handleSizeChange1"
                               @current-change="handleCurrentChange1"></el-pagination>
              </div>
            </el-footer>
          </el-main>
        </el-container>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
                        <el-button style="margin-top: -40px"
                                   @click="closeBatch">关闭</el-button>
                        <el-button style="margin-top: -40px" type="primary" @click="getOrderAll()"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>
  </div>
</template>

<style>

</style>

<script>
import request from "@/util/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'OrderGet',
  data() {
    const treeData = [];
    return {
      show: this.$route.query.show,
      currentPage: 1,
      pageSize: 10,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [], //未分页的数据
      currentPage1: 1,
      pageSize1: 10,
      total1: 10,
      small1: "small",
      background1: "background",
      prev1: this.currentPage1 - 1,
      pager1: this.currentPage1,
      next1: this.currentPage1 + 1,
      jumper1: this.currentPage1,
      ticket1: [], //未分页的数据
      tableData: [], //已分页的数据
      reload: 0,//判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",//判断是否已经点击了模糊查询
      orderId: '',
      createBy: '',
      shareSign: '',
      roleId: '',
      areaId: '',
      multipleSelection: [],
      sessions: {},
      props: {},
      search: '',
      inputOrderNo: '',
      createDateSearch: '',
      //领取弹窗
      allocationDialog: false,
      //领取弹窗表单
      allocationForm: {},
      //领取弹窗中选择用户
      selectUserName: [],
      //领取弹窗中选择框数据
      options: [],
      //批量领取弹窗
      allocationDialogInBatch: false,
      //批量分配弹窗
      allocationInbatchForm: {},
      //树文本查询
      filterText: '',
      treeData: JSON.parse(JSON.stringify(treeData)),
      show2: false,
      tableDataAdd: [],
      toggleRowArr: [],

    }
  },
  created() {
    this.load()
  },
  methods: {
    closeBatch() {//关闭弹窗
      this.allocationDialogInBatch = false;
      this.show2 = false
    },
    closeAllocation() {//关闭弹窗
      this.allocationDialog = false;
      this.selectUserName = []
    },
    //刷新按钮
    refresh() {
      this.load()
      this.inputOrderNo = ''
      this.search = ''
      this.createDateSearch = ''
      this.currentPage = 1
    },
    // //工单号查询
    // searchByOrderNo() {
    //   if (this.inputOrderNo == null || this.inputOrderNo === "") {
    //     this.load()
    //   }
    //   this.createBy = sessionStorage.getItem('userName')
    //   request.get('/order/searchByOrderNoInGet', {
    //     params: {
    //       userName: this.createBy,
    //       orderNo: this.inputOrderNo
    //     }
    //   }).then(res => {
    //     this.ticket = res;
    //     this.total = this.ticket.length
    //     this.getPageInfo();
    //   })
    // },
    // //使用单位条件查询
    // qSearch() {
    //   if (this.search == null || this.search === "") {
    //     this.load()
    //   }
    //   this.userName = sessionStorage.getItem('userName')
    //   request.get('/order/searchOrderGet', {
    //     params: {
    //       userName: this.userName,
    //       unit: this.search
    //     }
    //   }).then(res => {
    //     this.ticket = res;
    //     this.total = this.ticket.length
    //     this.getPageInfo();
    //   })
    // },
    //根据创建日期查询
    searchByCreateDate() {
      if (this.createDateSearch === null && this.inputOrderNo === "" && this.search === "" || (this.createDateSearch === "" && this.inputOrderNo === "" && this.search === "")) {
        this.load()
      } else {
        this.userName = sessionStorage.getItem('userName')
        let map = {
          userName: this.userName,
          createDate: this.createDateSearch.toString(),
          unit: this.search,
          orderNo: this.inputOrderNo
        }
        request.post('/order/searchByInfoOrderGet', map).then(res => {
          this.ticket = res;
          this.total = this.ticket.length
          this.getPageInfo();
        })
      }
      // if (this.createDateSearch == null || this.createDateSearch === "") {
      //   this.load()
      // }
      // this.userName = sessionStorage.getItem('userName')
      // request.get('/order/createDateOrderGet', {
      //   params: {
      //     userName: this.userName,
      //     createDate: this.formatDate(this.createDateSearch, "yyyy-MM-dd")
      //   }
      // }).then(res => {
      //   this.ticket = res;
      //   this.total = this.ticket.length
      //   this.getPageInfo();
      // })
    },
    //全选按钮   批量查询
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return ""
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    //页面初始化 userName登录用户查
    load() {
      this.userName = sessionStorage.getItem('userName')
      request.post('/order/getOrderQuery?userName=' + this.userName).then(res => {
        this.ticket = res;
        this.total = this.ticket.length;
        this.getPageInfo()
      })
    },
    //领取按钮点击事件
    getOrder(row) {
      this.allocationDialog = true;
      this.allocationForm = JSON.parse(JSON.stringify(row));
    },
    //领取工单弹窗 点击选择框 显示该该电梯区域下的用户名
    userNameByLiftId() {
      this.options = []
      //使用userName排除展示登录用户自己
      let a = sessionStorage.getItem('userName')
      request.get('/order/userNameByLiftId', {
        params: {liftId: this.allocationForm.liftId}
      }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].userName !== a) {
            this.options.push(res.data[i])
          }
        }
      })
    },
    //领取确认按钮点击事件
    update() {
      if (this.selectUserName.length !== 1) {
        this.$message({
          type: 'warning',
          message: '请选择辅检人员!'
        });
      } else {
        this.allocationDialog = false;
        // this.allocationForm.userAlias = this.options[this.selectUserName].userAlias.toString() + ',' + sessionStorage.getItem('userAlias')
        this.allocationForm.userAlias = sessionStorage.getItem('userAlias') + ',' + this.options[this.selectUserName].userAlias.toString()
        this.allocationForm.userName = sessionStorage.getItem('userName') + ',' + this.options[this.selectUserName].userName.toString()
        request.get('/order/getOrder', {
          params: {
            userName: this.allocationForm.userName,
            userAlias: this.allocationForm.userAlias,
            orderId: this.allocationForm.orderId,
            updateBy: sessionStorage.getItem('userAlias'),
          }
        }).then(res => {
          if (res.code.code === 200) {
            this.$message({
              type: 'success',
              message: '领取成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: res.data
            });
          }
          this.searchByCreateDate() ;
          this.allocationForm = {};
          this.selectUserName = [];
        })
      }
      this.selectUserName = []
    },
    //批量领取按钮点击事件
    //批量领取工单按钮
    // 使用登录用户名查询 userName
    allocationInBatch() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          type: 'warning',
          message: '请勾选再操作!'
        });
      } else {
        this.allocationDialogInBatch = true;
        this.userName = sessionStorage.getItem('userName')
        request.get('/order/list2', {
          params: {
            userName: this.userName
          }
        }).then(res => {
          this.treeData = res.data.structList;
        })
      }
    },
    //批量领取确认
    getOrderAll() {
      this.allocationDialogInBatch = true;
      if (this.toggleRowArr.length !== 1) {
        this.$message({
          type: 'warning',
          message: '请选择一个辅检人员!'
        });
      } else {
        let arr = []
        arr.push(sessionStorage.getItem('userAlias'))
        for (let j = 0; j < this.toggleRowArr.length; j++) {
          arr.push(this.toggleRowArr[j].userAlias)
        }

        this.allocationInbatchForm.userAlias = arr.toString()
        let orderIdList = []
        this.multipleSelection.forEach(item => {
          item.userAlias = this.allocationInbatchForm.userAlias
          orderIdList.push(item.orderId)
        })
        //获取对应的userName
        let array = []
        array.push(sessionStorage.getItem('userName'))
        for (let t = 0; t < this.toggleRowArr.length; t++) {
          array.push(this.toggleRowArr[t].userName)
        }

        this.allocationInbatchForm.userName = array.toString()
        request.post('/order/orderUpdateInBatch', {
          userAlias: this.allocationInbatchForm.userAlias,
          userName: this.allocationInbatchForm.userName,
          ids: orderIdList,
          updateBy: sessionStorage.getItem('userAlias'),
        }).then(res => {
          if (res.code.code === 200) {
            this.$message({
              type: 'success',
              message: '批量分配成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '批量分配失败'
            });
          }
          this.allocationDialogInBatch = false;
          this.searchByCreateDate() ;
        })
      }
      this.show2 = false
    },
    //区域树查询所属用户
    handleNodeClickInbatch(data) {
      this.tableDataAdd = []
      if (data.areaLevel === 3) {//data.areaLevel === 5
        this.show2 = true
        this.areaId = data.areaId
        let arr = []
        //使用userName排除展示登录用户自己
        let a = sessionStorage.getItem('userName')
        request.get('/order/getUserName', {
          params: {
            areaId: this.areaId
          }
        }).then(res => {
          arr = res.data
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].userName !== a) {
              this.tableDataAdd.push(arr[i])
            }
          }
          // this.tableDataAdd = res.data
          this.ticket1 = this.tableDataAdd;
          this.total1 = this.ticket1.length;
          this.getPageInfo1();
        })
      }
    },
    tableRowClassName1({rowIndex}) {
      for (var i = 0; i < this.tableDataAdd.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo()
    },
    tableRowClassName({rowIndex}) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    },
    handleSizeChange1(pageSize) {
      //修改当前每页的数据行数
      this.pageSize1 = pageSize;
      //数据重新分页
      this.getPageInfo1();
    },
    handleCurrentChange1(pageNum) {
      //修改当前的页码
      this.currentPage1 = pageNum;
      //数据重新分页
      this.getPageInfo1()
    },
    //新建工单电梯表格分页
    getPageInfo1() {
      //清空pageTicket中的数据
      this.tableDataAdd = [];
      // 获取当前页的数据
      for (let i = (this.currentPage1 - 1) * this.pageSize1; i < this.total1; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableDataAdd.push(this.ticket1[i]);
        //判断是否达到一页的要求
        if (this.tableDataAdd.length === this.pageSize1) break;
      }
    },
    getRowUserId(row) {
      return row.userId
    },
  }
};
</script>